module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-ExtraBold.bb99f803.woff";